"use client";

import * as React from "react";

export default function AiLearningToggle() {
  const [busy, setBusy] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [enabled, setEnabled] = React.useState(true);
  const [msg, setMsg] = React.useState<string | null>(null);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch("/api/admin/company/ai-learning", { cache: "no-store" });
        const json = await res.json();
        if (!alive) return;
        if (!res.ok || !json.ok) {
          setMsg("❌ Status konnte nicht geladen werden.");
          return;
        }
        setEnabled(Boolean(json.enabled));
      } catch {
        if (alive) setMsg("❌ Verbindung fehlgeschlagen.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  async function save(next: boolean) {
    if (busy || loading) return;
    if (next === enabled) return;
    setBusy(true);
    setMsg(null);
    try {
      const res = await fetch("/api/admin/company/ai-learning", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ enabled: next })
      });
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json.error || "Speichern fehlgeschlagen");
      setEnabled(Boolean(json.enabled));
      setMsg(`✅ KI-Lernen ist jetzt ${json.enabled ? "EIN" : "AUS"}.`);
    } catch (e) {
      setMsg(e instanceof Error ? `❌ ${e.message}` : "❌ Fehler");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button className="btn" type="button" disabled={busy || loading || enabled} onClick={() => save(true)}>
          KI-Lernen EIN
        </button>
        <button className="btn" type="button" disabled={busy || loading || !enabled} onClick={() => save(false)}>
          KI-Lernen AUS
        </button>
        <span style={{ color: "var(--muted)" }}>
          Status: <strong>{loading ? "Laden…" : enabled ? "EIN" : "AUS"}</strong> (mandatsweit)
        </span>
      </div>
      {msg ? <div style={{ marginTop: 8, color: "var(--muted)" }}>{msg}</div> : null}
    </div>
  );
}

